import { type FC } from "react";

export const Initials: FC<{
  name: string;
}> = ({ name }) =>
  name
    .split(" ")
    .map((word) => word[0])
    .join("");
